import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props => props.theme.icon};
`;

const RightArrow = props => {
  if (window.innerWidth > 1800)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33.416"
        height="28.001"
        viewBox="0 0 33.416 28.001"
        {...props}
      >
        <G transform="translate(.002 .707)" fill="none" strokeWidth="2">
          <path
            d="M0,0,13.294,13.294,0,26.587"
            transform="translate(18.706)"
            strokeMiterlimit="10"
          />
          <line x1="31.111" y2="0.07" transform="translate(0 13.43)" />
        </G>
      </svg>
    );
  else
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.584"
        height="17.221"
        viewBox="0 0 20.584 17.221"
        {...props}
      >
        <G transform="translate(.001 .354)" fill="none">
          <path
            d="M0,0,8.257,8.257,0,16.514"
            transform="translate(11.619)"
            strokeMiterlimit="10"
          />
          <line x1="19.323" y2="0.043" transform="translate(0 8.342)" />
        </G>
      </svg>
    );
};

export default RightArrow;
